import { autoinject } from "aurelia-framework";

/**
 * Represents the indicator to be shown while a view is busy.
 */
@autoinject
export class BusyIndicatorCustomElement
{
}
